import { combineReducers } from 'redux';
import SideDrawerReducer from '../SideDrawer/SideDrawer.reducer';
import { INITIALIZE_COMPLETE, INITIALIZE_RESET } from 'src/common/actions/constants';
import masterDataReducer from './masterDataReducer';
import vehicleRequestReducer from '../../components/pages/VehicleRequests/VehicleRequest.reducer';
import deliveryAcknowledgementReducer from 'src/components/pages/Delivery/DeliveryAcknowledgement.reducer';
import persistentIframe from './persistent-iframe';
import AssignedVehiclesReducer from 'src/components/pages/AssignedVehicles/AssignedVehicles.reducer';
import AssignedDriversReducer from 'src/components/pages/AssignedDrivers/AssignedDrivers.reducer';
import MoveableAssetsReducer from 'src/components/pages/MoveableAssets/MoveableAssets.reducer';
import notificationReducer from './notificationReducer';
import TicketManagementReducer from 'src/components/Ticket-managment/TicketManagement.reducer';
import InvoicesReducer from 'src/components/pages/Invoices/Invoices.reducer';
import receivablesReducer from '../../components/pages/Receivables/Receivables.reducer';
import downloadRequestsReducer from '../../components/pages/DownloadRequests/DownloadRequests.reducer';

const initializing = (state = true, action) => {
  switch (action.type) {
    case INITIALIZE_COMPLETE:
      return false;
    case INITIALIZE_RESET:
      return true;

    default:
      return state;
  }
};

export default combineReducers({
  initializing,
  masterData: masterDataReducer,
  vehicleRequest: vehicleRequestReducer,
  deliveryAcknowledgement: deliveryAcknowledgementReducer,
  assignedVehicles: AssignedVehiclesReducer,
  assignedDrivers: AssignedDriversReducer,
  moveableAssets: MoveableAssetsReducer,
  SideDrawerReducer,
  persistentIframe,
  notificationReducer,
  ticketingTool: TicketManagementReducer,
  invoices: InvoicesReducer,
  receivables: receivablesReducer,
  downloadRequests: downloadRequestsReducer,
});
